import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "../seo/setPageMeta";
import FlyerModal from "../components/FlyerModal";

function isImageFlyer(flyerPath) {
  return /\.(jpe?g|png)$/i.test(flyerPath || "");
}

export default function Home() {
  const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  const [announcement, setAnnouncement] = useState(null);
  const [dailyEncouragement, setDailyEncouragement] = useState(null);
  const [flyerModalOpen, setFlyerModalOpen] = useState(false);

  useEffect(() => {
    setPageMeta({
      title: "Celebrate Recovery | Home",
      description:
        "Celebrate Recovery is a Christ-centered recovery ministry for anyone facing hurts, habits, or hang-ups. Join us for support, healing, and hope.",
      canonical: "https://www.crindependenceky.com/",
    });

    fetchLatestAnnouncement();
    fetchLatestEncouragement();
  }, []);

  async function fetchLatestAnnouncement() {
    try {
      const response = await fetch(`${API_URL}/api/announcements/latest`);
      const data = await response.json();

      if (response.ok && data) {
        setAnnouncement(data);
      }
    } catch (error) {
      console.error("Failed to fetch latest announcement:", error);
    }
  }

  async function fetchLatestEncouragement() {
    try {
      const response = await fetch(`${API_URL}/api/daily-encouragement/latest`);
      const data = await response.json();

      if (response.ok && data) {
        setDailyEncouragement(data);
      }
    } catch (error) {
      console.error("Failed to fetch daily encouragement:", error);
    }
  }

  return (
    <>
      <section className="hero">
        <h2>Welcome to Celebrate Recovery</h2>

        <p>
          Celebrate Recovery is a Christ-centered recovery ministry for anyone
          dealing with hurts, habits, or hang-ups. Whether you are walking
          through addiction, grief, anxiety, anger, fear, shame, control issues,
          or simply a season of pain, you are welcome here.
        </p>

        <div className="serenity-prayer">
          <h3>The Serenity Prayer</h3>

          <p className="prayer-text">
            God, grant me the serenity to accept the things I cannot change,
            courage to change the things I can, and wisdom to know the
            difference. Living one day at a time, enjoying one moment at a time;
            accepting hardship as a pathway to peace.
          </p>
        </div>

        <div className="button-row">
          <Link to="/new-here" className="btn btn-primary">
            I’m New Here
          </Link>

          <Link to="/meetings" className="btn btn-secondary">
            View Meeting Info
          </Link>

          <Link to="/prayer-request" className="btn btn-secondary">
            Prayer Requests
          </Link>
        </div>
      </section>

      {dailyEncouragement && (
  <section className="daily-encouragement-card">
    <div className="daily-encouragement-topbar">
      <span className="daily-encouragement-label">Daily Encouragement</span>

      {dailyEncouragement.createdAt && (
        <span className="daily-encouragement-date">
          {new Date(dailyEncouragement.createdAt).toLocaleDateString()}
        </span>
      )}
    </div>

    <div className="daily-encouragement-body">
      <p className="daily-encouragement-verse">
        “{dailyEncouragement.message}”
      </p>
      <p className="daily-encouragement-subtext">
        A reminder of hope for today.
      </p>
    </div>
  </section>
)}

      {announcement && (
        <section className="announcement-card">
          <div className="announcement-topbar">
            <span className="announcement-label">Latest Announcement</span>
            {announcement.date && (
              <span className="announcement-date-badge">
                {new Date(announcement.date + "T00:00:00").toLocaleDateString()}
              </span>
            )}
          </div>

          <div className="announcement-body">
            <h3 className="announcement-title">{announcement.title}</h3>
            <p className="announcement-message">{announcement.message}</p>

            {announcement.flyerPath && (
              isImageFlyer(announcement.flyerPath) ? (
                <button
                  type="button"
                  className="announcement-flyer-link"
                  onClick={() => setFlyerModalOpen(true)}
                >
                  <img
                    src={`${API_URL}${announcement.flyerPath}`}
                    alt={`${announcement.title} flyer`}
                    className="announcement-flyer-thumb"
                  />
                  <span className="announcement-flyer-caption">
                    View full flyer
                  </span>
                </button>
              ) : (
                <div className="announcement-actions">
                  <a
                    href={`${API_URL}${announcement.flyerPath}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    View Flyer
                  </a>
                </div>
              )
            )}
          </div>
        </section>
      )}

      {flyerModalOpen && announcement?.flyerPath && (
        <FlyerModal
          flyerUrl={`${API_URL}${announcement.flyerPath}`}
          title={announcement.title}
          onClose={() => setFlyerModalOpen(false)}
        />
      )}

      <section className="grid-3">
        <div className="card">
          <h3>Where We Meet</h3>
          <p>Community Family Church</p>
          <p>11875 Taylor Mill Rd, Independence, KY 41051</p>
          <p>Room F227, 2nd Floor of the Family Life Center</p>
        </div>

        <div className="card">
          <h3>What to Expect</h3>
          <p>
            A warm environment, worship, teaching or testimony, and recovery
            groups rooted in hope and confidentiality.
          </p>
        </div>

        <div className="card">
          <h3>Confidential, Always</h3>
          <p>
            What you share stays in the room. Come as you are, at your own
            pace.
          </p>
        </div>
      </section>
    </>
  );
}